import { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { useDispatch, useSelector } from 'react-redux';
import {
    handleNoticePopupShow,
    handleNoticePopupClose,
    loadNoticePopupData,
} from '../module/component/NoticePopupModule';

// Swiper
import { Autoplay, Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import NullCheckUtil from '../util/NullCheckUtil';
import { useNavigate } from 'react-router-dom';
import { COMMUNITY_NOTICE_DETAIL_PATH, PATH_DELIMITER } from '../constant/Constant';

let COOKIE_NAME = 'noticePopupHide';

const NoticePopup = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [checked, setChecked] = useState(false);
    const [cookies, setCookie, removeCookie] = useCookies([COOKIE_NAME]);
    const { open, popups } = useSelector((state) => state.noticePopupState);
    const [images, setImages] = useState([]);

    const onChange = (e) => {
        setChecked(e.target.checked);
        if (e.target.checked) {
            // maxAge: 단위 초
            setCookie(COOKIE_NAME, e.target.checked, { maxAge: 86400 });
            // check 하면 창닫기
            dispatch(handleNoticePopupClose());
        } else {
            removeCookie(COOKIE_NAME);
        }
    };

    useEffect(() => {
        if (
            cookies.noticePopupHide == undefined ||
            (cookies.noticePopupHide != undefined && cookies.noticePopupHide == false)
        ) {
            dispatch(
                loadNoticePopupData({
                    callback: (result) => {
                        if (result > 0) {
                            dispatch(handleNoticePopupShow());
                        }
                    },
                }),
            );
        } else {
            setChecked(true);
            dispatch(handleNoticePopupClose());
        }
    }, []);

    useEffect(() => {
        const images = [];
        if (NullCheckUtil.isNotNull(popups) && popups.length > 0) {
            popups.forEach((popup) => {
                const byteCharacters = window.atob(popup.noticeFileData);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {
                    type: ['images/png', 'images/jpeg', 'images/jpg', 'images/gif'],
                });
                const url = URL.createObjectURL(blob);
                images.push({ url, alt: popup.postingTitleNm, postingNo: popup.postingNo });
            });
        }
        setImages(images);
    }, [popups]);

    const handleCancel = () => {
        dispatch(handleNoticePopupClose());
    };

    const onClickImage = (postingNo) => {
        navigate(COMMUNITY_NOTICE_DETAIL_PATH + PATH_DELIMITER + postingNo);
        dispatch(handleNoticePopupClose());
    };

    if (open) {
        return (
            <>
                <div className='modal-open'>
                    <div className='modal fade show'>
                        <div className='modal-notice-wrap'>
                            <div className='modal-notice-box'>
                                <div className='modal-header'>
                                    <h2 className='modal-title'>중요 공지사항</h2>
                                    <button type='button' className='btn close' onClick={() => handleCancel()} />
                                </div>
                                <div className='modal-notice-checker'>
                                    <input
                                        type='checkbox'
                                        id='notice-today-close'
                                        checked={checked}
                                        onChange={onChange}
                                    />
                                    <label htmlFor='notice-today-close'>
                                        <span>24시간동안 보지않기</span>
                                    </label>
                                </div>

                                <div className='modal-body'>
                                    <div className='list-swipe-wrap'>
                                        {images.length == 1 ? (
                                            <>
                                                <img
                                                    src={images[0].url}
                                                    alt={images[0].alt}
                                                    width='100%'
                                                    onClick={(e) => onClickImage(images[0].postingNo)}
                                                />
                                            </>
                                        ) : (
                                            <Swiper
                                                spaceBetween={50}
                                                slidesPerView={1}
                                                autoHeight={true}
                                                loop={true}
                                                autoplay={{
                                                    delay: 5000,
                                                    disableOnInteraction: false,
                                                }}
                                                navigation={true}
                                                pagination={{ clickable: true }}
                                                modules={[Autoplay, Navigation, Pagination, Scrollbar, A11y]}
                                            >
                                                {images &&
                                                    images.map((image, index) => (
                                                        <SwiperSlide key={index}>
                                                            <img
                                                                src={image.url}
                                                                alt={image.alt}
                                                                width='100%'
                                                                onClick={(e) => onClickImage(image.postingNo)}
                                                            />
                                                        </SwiperSlide>
                                                    ))}
                                            </Swiper>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='modal-back fade show'></div>
                </div>
            </>
        );
    } else {
        return <></>;
    }
};

export default NoticePopup;
